module.exports = __webpack_public_path__ + "static/avatar@3x-22bd5cd22efc04293ae4447bc4fa7b18.png";